import { ResponseProductAttribute } from '@/data/types/Product';

export const getProductAttribute = (data: ResponseProductAttribute) => {
	const { values = [] } = data;
	const { identifier, value, id } = values[0] || {};

	return {
		id: Array.isArray(id) ? id[0] : id,
		identifier: Array.isArray(identifier) ? identifier[0] : identifier,
		value: Array.isArray(value) ? value[0] : value,
	};
};
